<template>
  <div class="container page">
    <van-nav-bar :title="$t('打榜记录')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('数据为空！')" />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number" v-public-i18n="v.name">{{ v.name }}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
              <!-- <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[0] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[1] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[2] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image> -->
              <!-- <span class="res-des middle">{{v.status === 0 ? 0 : v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span> -->
                            <span class="res-des middle">{{ recordResult(v, 'size') }}</span>
              <span class="res-des middle">{{ recordResult(v, 'parity') }}</span>
            </div>
          </div>
          <div class="topInfo ">
            <div class="totalMoney">
              <span>{{ $i18n.locale === 'ja-JP' ? '合計金額：' : ($i18n.locale === 'en-US' ? 'Total amount: ' : '当前打榜总金额：') }}{{ $withdrawQuote() ? $displayMoney(v.money) : '--' }}</span>
            </div>
          </div>
          <div class="titleContent">
            <div class="">
              <span style="display:block;">{{ $t('打榜礼物') }}</span>
            </div>
            <div class="">
              <span style="display:block;">{{ $i18n.locale === 'ja-JP' ? '金額' : ($i18n.locale === 'en-US' ? 'Amount' : '打榜金额') }}</span>
            </div>
            <div class="">
              <span style="display:block;">{{ $t('打榜状态') }}</span>
            </div>
            <div class="">
              <span style="display:block;">{{ $t('打榜时间') }}</span>
            </div>
          </div>
          <div class="titleContent" v-for="(item, index) in v.data" :key="index">
            <div class="">
              <span v-public-i18n="item.type">{{ item.type }}</span>
            </div>
            <div class="">
              <span>{{ $withdrawQuote() ? $displayMoney(item.money) : '--' }}</span>
            </div>
            <div class="">
              <span>{{ recordStatus(item) }}</span>
            </div>
            <div class="">
              <span>{{ recordTime(item) }}</span>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
    methods: {
          recordResult(record, kind) {
      if (Number(record.status) === 0) return 0;

      const values = Array.isArray(record.opencode)
        ? record.opencode
        : String(record.opencode || '').split(',');

      if (values.length !== 3) return '--';

      const numbers = values.map(value => Number(value));
      if (!numbers.every(value =>
        Number.isInteger(value) && value >= 1 && value <= 6
      )) {
        return '--';
      }

      const sum = numbers.reduce((total, value) => total + value, 0);
      const label = kind === 'size'
        ? (sum > 10 ? '糖心' : '烟花')
        : (sum % 2 !== 0 ? '玫瑰' : '火箭');

      return this.resultLabel(label);
    },
          resultLabel(value) {
      const original = value == null ? '' : String(value);
      const labels = {
        '糖心': { 'ja-JP': 'ハート', 'en-US': 'Heart' },
        '烟花': { 'ja-JP': '花火', 'en-US': 'Fireworks' },
        '玫瑰': { 'ja-JP': 'バラ', 'en-US': 'Rose' },
        '火箭': { 'ja-JP': 'ロケット', 'en-US': 'Rocket' }
      };
      const entry = labels[original];
      return entry && entry[this.$i18n.locale]
        ? entry[this.$i18n.locale]
        : original;
    },
    recordText(key) {
      const messages = {
        'zh-CN': {
          settling: '结算中',
          pending: '待结算',
          success: '成功',
          failed: '失败',
          unknown: '未知状态'
        },
        'ja-JP': {
          settling: '精算中',
          pending: '精算待ち',
          success: '成功',
          failed: '失敗',
          unknown: '不明'
        },
        'en-US': {
          settling: 'Settling',
          pending: 'Pending',
          success: 'Success',
          failed: 'Failed',
          unknown: 'Unknown'
        }
      };
      const current = messages[this.$i18n.locale] || messages['zh-CN'];
      return current[key] || '';
    },
    recordStatus(item) {
      const value = item.is_win;
      if (value !== null && value !== undefined && value !== '') {
        const status = Number(value);
        if (status === 0) return this.recordText('settling');
        if (status === 1) return this.recordText('success');
        if (status === 2) return this.recordText('failed');
      }

      // 兼容接口未提供状态码的记录，仅映射已知固定提示
      const fixed = {
        '结算中': 'settling',
        '成功': 'success',
        '失败': 'failed'
      };
      const key = fixed[item.win_text];
      return this.recordText(key || 'unknown');
    },
    recordTime(item) {
      const value = item.update_time;
      if (value === '待结算' || value === 0 || value === '0') {
        return this.recordText('pending');
      }
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
    back() {
      return window.history.back();
    },
        recordNotice(key) {
      const messages = {
        'zh-CN': {
          refreshed: '刷新成功',
          failed: '加载失败，请稍后重试',
          login: '登录已失效，请重新登录'
        },
        'ja-JP': {
          refreshed: '更新しました',
          failed: '読み込みに失敗しました。再度お試しください',
          login: '再度ログインしてください'
        },
        'en-US': {
          refreshed: 'Refreshed',
          failed: 'Unable to load. Please try again.',
          login: 'Please sign in again.'
        }
      };
      const current = messages[this.$i18n.locale] || messages['zh-CN'];
      return current[key] || '';
    },
    async onRefresh() {
      try {
        const success = await this.getUserGameList();
        if (success) {
          this.$toast(this.recordNotice('refreshed'));
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getUserGameList() {
      try {
        const res = await this.$http({
          method: 'get',
          url: 'user_get_game_list'
        });

        if (res && Number(res.code) === 200 && Array.isArray(res.data)) {
          this.list = res.data;
          return true;
        }

        if (res && Number(res.code) === 401) {
          this.$toast(this.recordNotice('login'));
        } else {
          this.$toast(this.recordNotice('failed'));
        }
        return false;
      } catch (error) {
        this.$toast(this.recordNotice('failed'));
        return false;
      }
    }

  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.titleContent {
  display: flex;
  justify-content: space-between;
}

.titleContent div {
  width: 25%;
  text-align: center;
  color: #e6b98a;
}

.item_list .topInfo .totalMoney {
  flex: 1;
  font-size: 4.667vw;
  font-weight: 700;
  color: red;
  display: flex;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  /* background-color: #f2f2f5; */
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #282828;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #ddb285;
}

.item_list .topInfo span:last-child {
  float: right;
}

.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}

.item_list .period-number {
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #ddb285;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #ddb285;
}

.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}</style>
